import DebugRender from './DebugRender';

export default DebugRender;
